const __all = {
  "__active": {
    "tenant": "zenvoya",
    "name": "Zenvoya",
    "assistantName": "Zoya",
    "logo": {
      "wordmark": "/brand/logo/wordmark.svg",
      "booking": "/brand/logo/booking.svg"
    },
    "chatAvatar": "/brand/illustrations/chat-avatar.svg",
    "sidebarMascot": "/brand/logo/sidebar-mascot.svg",
    "iconsDir": "/brand/icons",
    "images": {
      "assistantMark": "/brand/images/fox.svg",
      "assistantMarkPassive": "/brand/images/fox-passive.png",
      "character": "/brand/images/character.svg",
      "askAssistant": "/brand/images/ask-assistant.png",
      "supportMascot": "/brand/images/support-mascot.png",
      "homeBg": "/brand/images/home-bg.svg",
      "assistantLuggage": "/brand/images/travel-booking-confirmation.svg",
      "chatLoader": "/brand/images/fox.svg",
      "avatar": "/brand/images/avatar.png",
      "mapFox": "/brand/images/map-empty-comments.svg",
      "confirmLogo": "/brand/images/travel-booking-confirmation.svg",
      "failedLogo": "/brand/images/travel-booking-failed.svg",
      "activityUnavailable": "/brand/images/travel-booking-failed.svg",
      "supportIcon": "/brand/images/24-7-support-flights-hotels.svg",
      "activityHelp": "/brand/images/24-7-support-activities.svg"
    }
  },
  "aldar": {
    "tenant": "aldar",
    "name": "Al Dar Exchange",
    "assistantName": "Zoya",
    "logo": {
      "wordmark": "/brand/t/aldar/logo/wordmark.png",
      "booking": "/brand/t/aldar/logo/wordmark-horizontal.png"
    },
    "chatAvatar": "/brand/t/aldar/illustrations/chat-avatar.png",
    "sidebarMascot": "/brand/t/aldar/logo/sidebar-mascot.png",
    "iconsDir": "/brand/t/aldar/icons",
    "images": {
      "assistantMark": "/brand/t/aldar/images/mark.png",
      "assistantMarkPassive": "/brand/t/aldar/images/mark.png",
      "character": "/brand/t/aldar/images/mark.png",
      "askAssistant": "/brand/t/aldar/images/mark.png",
      "supportMascot": "/brand/t/aldar/images/mark.png",
      "homeBg": "/brand/t/aldar/images/home-bg.svg",
      "assistantLuggage": "/brand/t/aldar/images/travel-booking-confirmation.svg",
      "chatLoader": "/brand/t/aldar/images/mark.png",
      "avatar": "/brand/t/aldar/images/mark.png",
      "mapFox": "/brand/t/aldar/images/map-empty-comments.svg",
      "confirmLogo": "/brand/t/aldar/images/travel-booking-confirmation.svg",
      "failedLogo": "/brand/t/aldar/images/travel-booking-failed.svg",
      "activityUnavailable": "/brand/t/aldar/images/travel-booking-failed.svg",
      "supportIcon": "/brand/t/aldar/images/24-7-support-flights-hotels.svg",
      "activityHelp": "/brand/t/aldar/images/24-7-support-activities.svg"
    }
  },
  "indigo": {
    "tenant": "indigo",
    "name": "IndiGo",
    "assistantName": "Zoya",
    "logo": {
      "wordmark": "/brand/t/indigo/logo/wordmark.png",
      "booking": "/brand/t/indigo/logo/wordmark.png"
    },
    "chatAvatar": "/brand/t/indigo/illustrations/chat-avatar.svg",
    "sidebarMascot": "/brand/t/indigo/logo/sidebar-mascot.svg",
    "iconsDir": "/brand/t/indigo/icons",
    "images": {
      "assistantMark": "/brand/t/indigo/images/plane.svg",
      "assistantMarkPassive": "/brand/t/indigo/images/plane.svg",
      "character": "/brand/t/indigo/images/plane.svg",
      "askAssistant": "/brand/t/indigo/images/ask-assistant.svg",
      "supportMascot": "/brand/t/indigo/images/plane.svg",
      "homeBg": "/brand/t/indigo/images/home-bg.svg",
      "assistantLuggage": "/brand/t/indigo/images/travel-booking-confirmation.svg",
      "chatLoader": "/brand/t/indigo/images/plane-loader.svg",
      "avatar": "/brand/t/indigo/images/plane.svg",
      "mapFox": "/brand/t/indigo/images/map-empty-comments.svg",
      "confirmLogo": "/brand/t/indigo/images/travel-booking-confirmation.svg",
      "failedLogo": "/brand/t/indigo/images/travel-booking-failed.svg",
      "activityUnavailable": "/brand/t/indigo/images/travel-booking-failed.svg",
      "supportIcon": "/brand/t/indigo/images/24-7-support-flights-hotels.svg",
      "activityHelp": "/brand/t/indigo/images/24-7-support-activities.svg"
    }
  },
  "navi": {
    "tenant": "navi",
    "name": "Navi",
    "assistantName": "Zoya",
    "logo": {
      "wordmark": "/brand/t/navi/logo/wordmark.svg",
      "booking": "/brand/t/navi/logo/wordmark.svg"
    },
    "chatAvatar": "/brand/t/navi/illustrations/chat-avatar.png",
    "sidebarMascot": "/brand/t/navi/logo/sidebar-mascot.png",
    "iconsDir": "/brand/t/navi/icons",
    "images": {
      "assistantMark": "/brand/t/navi/images/mark.png",
      "assistantMarkPassive": "/brand/t/navi/images/mark.png",
      "character": "/brand/t/navi/images/mark.png",
      "askAssistant": "/brand/t/navi/images/mark.png",
      "supportMascot": "/brand/t/navi/images/mark.png",
      "homeBg": "/brand/t/navi/images/home-bg.svg",
      "assistantLuggage": "/brand/t/navi/images/travel-booking-confirmation.svg",
      "chatLoader": "/brand/t/navi/images/mark.png",
      "avatar": "/brand/t/navi/images/mark.png",
      "mapFox": "/brand/t/navi/images/map-empty-comments.svg",
      "confirmLogo": "/brand/t/navi/images/travel-booking-confirmation.svg",
      "failedLogo": "/brand/t/navi/images/travel-booking-failed.svg",
      "activityUnavailable": "/brand/t/navi/images/travel-booking-failed.svg",
      "supportIcon": "/brand/t/navi/images/24-7-support-flights-hotels.svg",
      "activityHelp": "/brand/t/navi/images/24-7-support-activities.svg"
    }
  },
  "snoonu": {
    "tenant": "snoonu",
    "name": "Snoonu",
    "assistantName": "Zoya",
    "logo": {
      "wordmark": "/brand/t/snoonu/logo/wordmark.svg",
      "booking": "/brand/t/snoonu/logo/wordmark.svg"
    },
    "chatAvatar": "/brand/t/snoonu/illustrations/chat-avatar.svg",
    "sidebarMascot": "/brand/t/snoonu/logo/sidebar-mascot.svg",
    "iconsDir": "/brand/t/snoonu/icons",
    "images": {
      "assistantMark": "/brand/t/snoonu/images/mark.svg",
      "assistantMarkPassive": "/brand/t/snoonu/images/mark.svg",
      "character": "/brand/t/snoonu/images/mark.svg",
      "askAssistant": "/brand/t/snoonu/images/mark.svg",
      "supportMascot": "/brand/t/snoonu/images/mark.svg",
      "homeBg": "/brand/t/snoonu/images/home-bg.svg",
      "assistantLuggage": "/brand/t/snoonu/images/travel-booking-confirmation.svg",
      "chatLoader": "/brand/t/snoonu/images/mark.svg",
      "avatar": "/brand/t/snoonu/images/mark.svg",
      "mapFox": "/brand/t/snoonu/images/map-empty-comments.svg",
      "confirmLogo": "/brand/t/snoonu/images/travel-booking-confirmation.svg",
      "failedLogo": "/brand/t/snoonu/images/travel-booking-failed.svg",
      "activityUnavailable": "/brand/t/snoonu/images/travel-booking-failed.svg",
      "supportIcon": "/brand/t/snoonu/images/24-7-support-flights-hotels.svg",
      "activityHelp": "/brand/t/snoonu/images/24-7-support-activities.svg"
    }
  }
} as const;

type __Shape = (typeof __all)["__active"];
const __tenant = typeof document !== "undefined" ? document.documentElement.getAttribute("data-zv-tenant") || "" : "";
const __hit = __tenant !== "__active" ? (__all as unknown as Record<string, __Shape | undefined>)[__tenant] : undefined;
const __pick: __Shape = __hit ?? __all.__active;

export const brand = __pick;

/** Tenant this page runs as, picked by domain or ?partner= ("" when none matched: default build / partner branding). */
export const hostTenant: string = __hit ? __tenant : "";
